<div class="press-club-item-wrapper" (click)="redirectToUrl()">
    <div class="press-club-card" [ngStyle]="{ borderTop: '5px solid ' + colors[pressClubItem?.id % 10]}">
        <div class="title">
            {{pressClubItem.title}}
        </div>
        <div class="img-wrapper">
            <img [src]="pressClubItem?.media[0]?.cdn_path ? pressClubItem?.media[0]?.cdn_path : util.defaultImg" alt="press club img" />
        </div>
        <div class="extra-data">
            <div class="date">
                <small>{{pressClubItem.source_date}}</small>
            </div>
            <div class="source">
                <small>{{pressClubItem.source}}</small>
            </div>
        </div>
        <div class="desc">
            {{pressClubItem.descr}}
        </div>
    </div>
</div>